/* eslint-disable @typescript-eslint/naming-convention */
import { LogLevel } from 'angular-auth-oidc-client';

export const environment = {
  production: false,
  appName: 'Wedeco UV System',

  // XGS (Xylem Global Security) OIDC Configuration
  xgs: {
    clientId: '10cdff8b-ffca-42eb-9817-7c9376c264c0',
    baseUrl: 'https://cloudfront-qa.xylem-cloud.com/xgs',
    idp: 'cloudfront-qa.xylem-cloud.com/xgs/auth/realms/xgsum',
    logLevel: LogLevel.Debug,
    domain: 'avensor.gcc-poc.com'
  },

  // Xylem API Configuration
  xylem: {
    apiBaseUrl: '/api/v1', // Proxied in development to avoid CORS (used for alarms/devices/config)
    stationId: '177a7f32-f648-4b05-91fd-e403bb335ad0',
    deviceId: '7943f437-d949-4079-b99a-bb88c234c2e6'
  },

  // AWS Cognito Identity Pool (for IAM-authenticated API calls)
  cognito: {
    identityPoolId: 'us-east-1:320e7dbf-8764-4830-a05d-b6964d61cc70',
    region: 'us-east-1',
    oidcProvider: 'cloudfront-qa.xylem-cloud.com/xgs/auth/realms/xgsum'
  },

  // AWS API Gateway endpoints (station_id passed as query param)
  aws: {
    baseUrl: 'https://api.avensor.gcc-poc.com',
    stations: 'https://api.avensor.gcc-poc.com/stations',
    liveData: 'https://api.avensor.gcc-poc.com/live-data',
    historicalData: 'https://api.avensor.gcc-poc.com/historical-data'
  },

  // Xylem API endpoints (proxied, station_id in path)
  api: {
    baseUrl: '/api/v1',
    lampDetails:
      '/api/v1/stations/177a7f32-f648-4b05-91fd-e403bb335ad0/devices',
    configuration:
      '/api/v1/stations/177a7f32-f648-4b05-91fd-e403bb335ad0/alarms/configuration',
    alarms: '/api/v1/stations/177a7f32-f648-4b05-91fd-e403bb335ad0/alarms'
  },

  // Polling configuration (in milliseconds)
  polling: {
    liveDataInterval: 60000, // 60 seconds for live data
    lampDetailsInterval: 30000, // 30 seconds for lamp details
    configInterval: 60000 // 60 seconds for configuration
  },

  // Request headers
  request: {
    headers: {
      'Content-Type': 'application/json',
      'APP-ID': 'wedeco-angular'
    },
    withCredentials: false
  }
};
